import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Retired 2026-09-15 — the canonical path is `/verify` (legacy parity, PRD 13).
 * v2 verification emails already sent point here, so this redirects rather than 404s.
 */
export const Route = createFileRoute("/email-verify")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/verify", search, replace: true });
  },
});
